import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactPensionPreviewComponent } from './contact-pension-preview.component';
import {PensionReservePreviewModule} from '../pension-reserve-preview/pension-reserve-preview.module';
import {PensionReserveChartsModule} from '../pension-reserve-charts/pension-reserve-charts.module';
import {MainContactComponentsModule} from '../../../../../lifeislife-front/src/app/main/components/contact/main-contact-components.module';



@NgModule({
  declarations: [ContactPensionPreviewComponent],
  imports: [
    CommonModule,
    PensionReservePreviewModule,
    PensionReserveChartsModule,
    MainContactComponentsModule,
  ],
  exports: [ContactPensionPreviewComponent]
})
export class ContactPensionPreviewModule { }
